module.exports = __webpack_public_path__ + "static/media/ps_powerbutton_icon.302316fe.svg";